import { computed } from 'vue'
import { LS_LOCALE_KEY } from '@/constants'
import { appLocale } from '@deepcloud/deep-ui-kit'
import { useKeycloak } from './auth/keycloak'

export function useAppLocale() {
  const { availableLocales } = useI18n()
  const { bearer, isAuthenticated, updateToken, user } = useKeycloak()

  return appLocale({
    supportedLocales: availableLocales,
    storageKey: LS_LOCALE_KEY,
    initialLocale: computed(() =>
      isAuthenticated.value ? user.value?.locale : undefined,
    ),
    persist: {
      enabled: computed(() => !!isAuthenticated.value),
      apiToken: computed(() => bearer.value ?? ''),
      env: import.meta.env.VITE_ENVIRONMENT,
      userId: computed(() => user.value?.sub),
      afterPersist: async () => {
        await updateToken()
      },
    },
  })
}
